export const firstFormError = (messages?: string[]) => messages?.[0]
